jQuery.fn.allLazyLoaded = function(callback){
  'use strict';

  if(this.length){

    var lazy_class = '.' + 'dy_lazyLoader';

    var container = this;

    var images = jQuery(lazy_class, container);

    var config = {
      attributes: true,
      childList: false,
      characterData: false,
      subtree: true,
      attributeFilter: ['class']
    };


    var observer_image = new MutationObserver( function( localContainer, localImages, localCallback, mutations, observer) {

      var element = jQuery(mutations[0].target);
      var loadedClass = lazySizes.cfg.loadedClass;

      if(element.hasClass( loadedClass )){

        if ( localImages.not('.' + loadedClass).length === 0 ) {

          observer.disconnect();

          localCallback(localContainer);

        }

      }

    }.bind(null, container, images, callback));


    // Observamos todas las imágenes
    for ( var i = 0; i < images.length; i++ ) {

      // Elemento de imágen actual
      var img_current = images[i];

      // vigilamos la descarga de la imagen
      observer_image.observe( img_current, config);

      // le decimos a lazysizes que descargue la imagen aunque no este en el viewport
      lazySizes.loader.unveil(img_current);

    }

  }

  return this;
};


